<template>
  <div>
    <div>
      <span class="xbed-sub-title">活动详情</span>
    </div>
    <div class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>营销管理</BreadcrumbItem>
        <BreadcrumbItem>活动管理</BreadcrumbItem>
        <BreadcrumbItem>活动详情</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <br>
    <div class="table-style">
      <Row class="rowColor backColor">
        <Col span="8">
            <div>活动标题</div>
        </Col>
        <Col span="8">
            <div>{{dataInfos.title}}</div>
        </Col>
      </Row>
      <Row class="rowColor">
        <Col span="8">
            <div>活动开始时间</div>
        </Col>
        <Col span="8">
            <div>{{createDate}}</div>
        </Col>
      </Row>
      <Row class="rowColor backColor">
        <Col span="8">
            <div>活动结束时间</div>
        </Col>
        <Col span="8">
            <div>{{endDate}}</div>
        </Col>
      </Row>
      <Row class="rowColor">
        <Col span="8">
            <div>活动状态</div>
        </Col>
        <Col span="8">
            <tag color="warning">{{['','待上线','上线中','已下线'][dataInfos.state]}}</tag>
        </Col>
      </Row>
      <Row class="rowColor backColor">
        <Col span="8">
            <div>参与房间	</div>
        </Col>
        <Col span="8">
            <div>{{dataInfos.roomCondition}}</div>
        </Col>
      </Row>
      <Row class="rowColor">
        <Col span="8">
            <div>参与用户</div>
        </Col>
        <Col span="8">
            <div>{{dataInfos.userCondition}}</div>
        </Col>
      </Row>
      <Row class="rowColor backColor">
        <Col span="8">
            <div>参与订单</div>
        </Col>
        <Col span="8">
            <div>{{dataInfos.orderCondition}}</div>
        </Col>
      </Row>
      <Row class="rowColor">
        <Col span="8">
            <div>业务触发点</div>
        </Col>
        <Col span="8">
            <p>{{budinessName}}</p>
            <p>关键词：{{activationKeys ? activationKeys : '-'}}</p>
        </Col>
      </Row>
      <Row class="rowColor backColor">
        <Col span="8">
            <div>活动奖励</div>
        </Col>
        <Col span="10">
          <router-link  :to="{path:'/app/marketing/activityRewardContentList', query: {id: rewarId }}">
            <p>{{rewardName}}</p>
          </router-link>
          <div v-for="(item,index) in activityRewardArr" :key="index">
            <p v-if="item.type === 1">总金额打折：{{item.content/10}}折</p>
            <p v-if="item.type === 2">满减：￥{{item.content}}分</p>
            <p v-if="item.type === 3">赠送卡券ID：{{item.content}}</p>
            <p v-if="item.type === 4">赠送经验值：{{item.content}}</p>
            <p v-if="item.type === 5">赠送房晚：{{item.content}}个房晚</p>
            <p v-if="item.type === 6">指定金额：￥{{item.content}}分</p>
            <p v-if="item.type === 7">Xdollar：{{item.content}}Xdollar</p>
            <p v-if="item.type === 8">标签：{{item.content}}</p>
          </div>
        </Col>
      </Row>
      <Row class="rowColor">
        <Col span="8">
            <div>活动封面</div>
        </Col>
        <Col span="10">
            <div>
              <span style="margin-right:15px;">{{dataInfos.head}}</span>
              <Button type="primary" @click="checkAddress('cover')">查看</Button>
            </div>
        </Col>
      </Row>
      <Row class="rowColor backColor">
        <Col span="8">
            <div>活动详情图文</div>
        </Col>
        <Col span="10">
            <div>
              <span style="margin-right:15px;">{{dataInfos.content}}</span>
              <Button type="primary" @click="checkAddress('text')">查看</Button>
            </div>
        </Col>
      </Row>
      <Row class="rowColor">
        <Col span="8">
            <div>活动描述</div>
        </Col>
        <Col span="10">
            <div>{{dataInfos.describes}}</div>
        </Col>
      </Row>
    </div>
    <!-- 查看活动封面 -->
    <Modal v-model="checkCoverDisplay" title="查看活动封面" :loading="true" >
      <img class="img" :src="dataInfos.head" alt="" width="100%">
      <div slot="footer">
        <Button type="primary" @click="sureModal('cover')">确定</Button>
      </div>
    </Modal>
    <!-- 查看活动详情图文 -->
    <Modal v-model="checkTextDisplay" title="查看活动详情图文" :loading="true">
      <img class="img" :src="dataInfos.content" alt="" width="100%">
      <div slot="footer">
        <Button type="primary" @click="sureModal('text')">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import API from "@/api";
import Utils from "../../utils";
import Moment from "moment";
export default {
  created() {
    this.activityId = Utils.getUrlParameterByName( 'id' )
    this.rewarId = Utils.getUrlParameterByName( 'rewarid' )
		this.token = Utils.findFromLocalStorage( "vue-token" );
		this.username = Utils.findFromLocalStorage( "vue-username" );
    this.env = Utils.findFromLocalStorage( "env", "dev" );
    this.querActityList()
    this.businessData()
    this.rewardData()
    this.activityRewardContent()
	},
  data () {
    return {
      checkCoverDisplay:false,
      checkTextDisplay:false,
      dataInfos:{},
      businessSelect:[],
      rewardSelect:[],
      rewardName:'',
      budinessName:'',
      activationKeys:'',
      activityRewardArr:[]
    }
  },
  mounted() {
    this.$Notice.config({
			top: 200
		});
    this.querActityList()
    this.businessData()
    this.rewardData()
    this.activityRewardContent()
  },
  computed:{
    createDate : function(){
      let createDate = this.dataInfos.beginDatetime ? Moment(this.dataInfos.beginDatetime).format('YYYY-MM-DD HH:mm:ss'):'不限时';            
      return createDate
    },
    endDate:function(){
      let endDate = this.dataInfos.endDatetime ? Moment(this.dataInfos.endDatetime).format('YYYY-MM-DD HH:mm:ss'):'不限时';            
      return endDate
    }
  },
  methods: {
    async querActityList(){
      let params = {
        url:`/api/activity/${this.activityId}`,
      }
      let resp = (await API.omsAPI[this.env].marketing.actityManage('GET',params,this.token)).data
      if ( resp.retCode ) {
        this.$Notice.error({
          title: '获取页面数据失败',
          desc: resp.msg
        })
      return
      }
      this.dataInfos = resp
    },
    // 业务触发点数据
    async businessData(){
      let params = {
        url:'/api/activationConfig',
        page:0,
        size:99999
      }
      let resp = (await API.omsAPI[this.env].marketing.actityManage('GET',params,this.token)).data
      let allList = resp.content
      allList.forEach(ele =>{
        this.businessSelect.push({
          activationId:ele.activationId,
          name:ele.name,
          activationKeys:ele.keys
        })
      })
      this.businessSelect.forEach((ele) =>{
        if (ele.activationId === this.dataInfos.activationId) {
          this.budinessName = ele.name
          this.activationKeys = ele.activationKeys
        }
      })
    },
    // 活动奖励
    async rewardData(){
      let params = {
        url:'/api/activityReward',
        page:0,
        size:99999
      }
      let resp = (await API.omsAPI[this.env].marketing.actityManage('GET',params,this.token)).data
      let allList = resp.content
      allList.forEach(ele =>{
        this.rewardSelect.push({
          rewardId:ele.rewardId,
          name:ele.name
        })
      })
      this.rewardSelect.forEach((ele) =>{
        if (ele.rewardId === this.dataInfos.activityRewardId) {
          this.rewardName = ele.name
        }
      })
    },
    async activityRewardContent(){
      let params = {
        url:'/api/activityRewardContent',
        page:0,
        size:99999,
        rewardId:this.rewarId
      }
      let resp = (await API.omsAPI[this.env].marketing.actityManage('GET',params,this.token)).data
      this.activityRewardArr = resp
    },
    // 查看
    checkAddress(type){
      if (type === 'cover') {
        this.checkCoverDisplay = true
      }else if (type === 'text') {
        this.checkTextDisplay = true
      }
    },
    sureModal(type){
      if (type === 'cover') {
        this.checkCoverDisplay = false
      }else if (type === 'text') {
        this.checkTextDisplay = false
      }
    },
  }
}
</script>

<style lang="scss">
 .table-style{
    width: 1200px;
    border:1px solid rgb(119, 118, 118);
    margin:10px;
    padding:10px;
  }
  .rowColor{
    padding: 10px;
  }
  .backColor{
    background-color: #eee;
  }
</style>


// WEBPACK FOOTER //
// src/pages/marketing/activityDetailView.vue